import React from "react";

const DocumentsTab = () => {
  return (
    <div
      className="tab-pane fade"
      id="nav-documents"
      role="tabpanel"
      aria-labelledby="nav-documents-tab"
    >
      <div className="rounded-large bg-white border p-4 mt-xxl-5 mt-4">
        <h5>No activity found!</h5>
      </div>
    </div>
  );
};

export default DocumentsTab;
